import * as React from 'react';
import {connect} from 'react-redux';
import store from '../../redux/store';
import {Rnd} from 'react-rnd';
import ElementProps from '../ElempentProps';
import {
    addToDragElements,
    changeProperties,
    changePropertiesById,
    changePropertiesRange,
    doubleClick,
    dropElement,
    makeElementActive,
    removeAllDragElements,
    removeDragElements,
    updateElement
} from '../../redux/actions';
import DraggableRemoveHandler from './DraggableRemoveHandler';
import objeler from '../../components/objeler';
import './Draggable.css';
import {CalcGridCoord} from '../Functions/funcs';

const resizeHandlerClasses = {
    right: 'leftAndRight',
    left: 'leftAndRight',
    top: 'topAndBottom',
    bottom: 'topAndBottom',
    bottomLeft: 'handler',
    bottomRight: 'handler',
    topLeft: 'handler',
    topRight: 'handler'
};
type Props = {
    id: string,
    activeElementId: string,
    activeElement: {
        properties: {
            location: { x: number, y: number },
            size: { height: number | string, width: number | string }
        }
    },
    style: {},
    properties: {
        location: { x: number, y: number },
        size: { height: number | string, width: number | string }
    },
    makeElementActive: Function,
    changeProperties: Function,
    dropElement: Function,
    doubleClick: Function,
    updateElement: Function,
    children: React.Node
};

class Draggable extends React.Component<Props> {
    constructor(props) {
        super(props);
        this.parent = React.createRef();
        this.dropElement = this.dropElement.bind(this);
        this.state = {message: "None", oldElement: null, dragStop: false, shiftKey: false};
        objeler["Confirm"] = "none";
    }

    onSelectItem = (e) => {
        objeler.doubleClick = this.doubleClick;
        const {activeElement, addToDragElements, removeAllDragElements, removeDragElements, id} = this.props;
        if (e.shiftKey) {
            if (store.getState().appReducers.dragElements.length == 0 && this.state.oldElement != null)
                addToDragElements(this.state.oldElement);
            if (!this.isDragExist2(activeElement.id))
                addToDragElements(activeElement);
            else {
                removeDragElements(activeElement);
                const {makeElementActive, id} = this.props;
                makeElementActive(null);
                return;
            }
        } else {
            if (activeElement == null || !this.isDragExist(activeElement.id))
                removeAllDragElements()
        }
        ;
        const dragElements = store.getState().appReducers.dragElements;
        this.makeActiveIfIsNot();
    };
    onDragStart = (event, data) => {
        const {changeProperties, activeElement, id} = this.props;
        this.setState({oldElement: activeElement})
        this.makeActiveIfIsNot();
        var actEl = store.getState().appReducers.objects[id];
        var edt = document.querySelector('[rmeditor="' + actEl.PageId + '"]');
        var tar = document.getElementById("ceren");
        var oo = document.getElementById(actEl.id);
        this.setState({
            dragDifPageLoc:
                {
                    x: event.clientX - oo.getBoundingClientRect().x,
                    y: event.clientY - oo.getBoundingClientRect().y
                }
        }, () => {
        })
    };
    onDragStop = (event, data) => {
        const {changeProperties, changePropertiesById, RemoveIconScale, activeElement} = this.props;
        if (store.getState().appReducers.dragElements.length > 1)
            this.setState({dragStop: true})
        this.makeActiveIfIsNot();
        this.props.properties.Jpg = this.props.properties.JpgPath;
        changeProperties({Jpg: this.props.properties.JpgPath});
        {
            if (
                data.y + activeElement.properties.size.height > data.node.parentNode.offsetHeight - (9 / RemoveIconScale)
                ||
                data.y < (9 / RemoveIconScale)
            ) {
                var pageid = activeElement.PageId;
                const objs = store.getState().appReducers.objects;
                var el = document.elementFromPoint(event.clientX, event.clientY);
                while (el !== null && (!el.hasAttribute('id') || el.id !== 'editor')) {
                    el = el.parentElement;
                }
                if (el !== null) {
                    pageid = el.getAttribute('rmeditor');
                    ;
                    if (objs[activeElement.id].PageId !== parseInt(pageid)) {
                        {
                            var x = 0;
                            if (event.clientX - el.getBoundingClientRect().left - (this.state.dragDifPageLoc.x * 1) < 0)
                                x = 0;
                            else
                                x = event.clientX - el.getBoundingClientRect().left - 0 - (this.state.dragDifPageLoc.x / 1);
                            var y = 0;
                            if (event.clientY - el.getBoundingClientRect().top - (this.state.dragDifPageLoc.y * 1) < 0)
                                y = 0;
                            else
                                y = event.clientY - el.getBoundingClientRect().top - 0 - (this.state.dragDifPageLoc.y * 1);
                            x = x / RemoveIconScale;
                            y = y / RemoveIconScale;
                            if (x + objs[activeElement.id].properties.size.width > el.clientWidth)
                                x = (el.clientWidth - objs[activeElement.id].properties.size.width)
                            if (y + objs[activeElement.id].properties.size.height > el.clientHeight)
                                y = (el.clientHeight - objs[activeElement.id].properties.size.height);
                            if (objeler.EditorProps.ShowGridLines) {
                                x = CalcGridCoord(this.props.GridSize, x, true);
                                y = CalcGridCoord(this.props.GridSize, y, true);
                            }
                            objs[activeElement.id].PageId = parseInt(pageid);
                            objs[activeElement.id].properties.location.x = x;
                            objs[activeElement.id].properties.location.y = y;
                        }
                    }
                }
            }
        }
        const dragElements = store.getState().appReducers.dragElements;
        if (dragElements.length > 0)
            for (let prop in dragElements) {
                var tar = this.getElementTransform(dragElements[prop].id);
                x = tar.x;
                y = tar.y;
                if (objeler.EditorProps.ShowGridLines) {
                    x = CalcGridCoord(this.props.GridSize, x, true)
                    y = CalcGridCoord(this.props.GridSize, y, true)
                }
                var x = Math.round((x + (event.movementX / RemoveIconScale)) * 10000) / 10000;
                var y = Math.round((y + (event.movementY / RemoveIconScale)) * 10000) / 10000;
                if (x < 0) x = 0;
                if (y < 0) y = 0;
                if (dragElements[prop].id != activeElement.id) {
                    dragElements[prop].properties.location.x = x;
                    dragElements[prop].properties.location.y = y;
                }
            }
    };
    onResize = (e, direction, ref, delta, position) => {
        this.setState({shiftKey: e.shiftKey});
        this.makeActiveIfIsNot();
        const {changeProperties, type} = this.props;
        var vWidth = ref.clientWidth + 2;
        var vHeight = ref.clientHeight + 2;
        if (this.props.activeElement.type == "Lines" && this.props.activeElement.properties.Direction == "Horizontal" && vHeight < 20)
            vHeight = 20;
        if (this.props.activeElement.type == "Lines" && this.props.activeElement.properties.Direction == "Vertical" && vWidth < 20)
            vWidth = 20;
        var w = vWidth;
        var h = vHeight;
        var wR = vWidth;
        var hR = vHeight;
        if (objeler.EditorProps.ShowGridLines) {
            w = CalcGridCoord(this.props.GridSize, vWidth, true);
            h = CalcGridCoord(this.props.GridSize, vHeight, true);
        }
        var fw = Math.floor(w);
        var fh = Math.floor(h);
        var dw = w - fw;
        var dh = h - fh;
        if (dw != 0)
            w = fw + 0.5;
        if (dh != 0)
            h = fh + 0.5;
        if ('chl', this.props.activeElement.type == "Word") {
            h = this.props.children.ref.current.editor.editor.scrollHeight;
        }
        changeProperties({
            location: {
                x: position.x,
                y: position.y
            },
            size: {
                width: w,
                height: h
            }
        });
    };

    isDragExist(id) {
        try {
            const dragElements = store.getState().appReducers.dragElements;
            for (let prop in dragElements) {
                if (dragElements[prop].id == id) {
                    return true;
                }
            }
        } catch {
        }
        return false;
    }

    isDragExist2(id) {
        const dragElements = store.getState().appReducers.dragElements;
        for (let prop in dragElements) {
            if (dragElements[prop].id == id) {
                return true;
            }
        }
        return false;
    }

    getElementTransform = (id) => {
        var tar = document.getElementById(id).style.transform.replace("translate(", "").replace(")", "").replace(" ", "").replace("px", "").replace("px", "").split(",");
        return {
            x: parseFloat(tar[0]),
            y: parseFloat(tar[1])
        }
    }
    setElementTransform = (x, y) => {
        document.getElementById(id).style.transform = 'translate(' + x + 'px,' + y + 'px)';
    }
    onDrag = (event, data) => {
        this.makeActiveIfIsNot();
        const {
            changeProperties,
            changePropertiesById,
            changePropertiesRange,
            activeElement,
            RemoveIconScale,
            id
        } = this.props;
        var x = data.x;
        var y = data.y;
        const dragElements = store.getState().appReducers.dragElements;
        const objs = store.getState().appReducers.objects;
        if (objeler.EditorProps.ShowGridLines && dragElements.length == 0) {
            x = CalcGridCoord(this.props.GridSize, x, true)
            y = CalcGridCoord(this.props.GridSize, y, true)
        }
        x = Math.round(x * 10000) / 10000;
        y = Math.round(y * 10000) / 10000;
        if (x < 0) x = 0;
        if (y < 0) y = 0;
        if (dragElements.length == 0) {
            changeProperties({
                location: {
                    x: x,
                    y: y
                }
            });
            var el = $("#" + id);
            var cer = $('#ceren');
            var max = cer[0].scrollHeight - cer[0].clientHeight;
            if (objeler.Header.Height > el.offset().top - data.deltaY) {
                cer.animate({scrollTop: cer.scrollTop() - (objeler.Header.Height - el.offset().top) - 30}, 100, 'swing');
            }
            if (objeler.Footer.Height + el.offset().top + el.height() > $(window.top).height() - data.deltaY) {
                {
                    cer.animate({scrollTop: cer.scrollTop() + (objeler.Footer.Height + el.offset().top + el.height() - $(window.top).height()) + 30}, 100, 'swing');
                }
            }
            return;
        }
        var farkx = x - activeElement.properties.location.x;
        var farky = y - activeElement.properties.location.y;
        var stop = false;
        for (let prop in dragElements) {
            var tar = this.getElementTransform(dragElements[prop].id);
            x = tar.x;
            y = tar.y;
            var x = Math.round((x + (farkx)) * 10000) / 10000;
            var y = Math.round((y + (farky)) * 10000) / 10000;
            if (x < 0) {
                x = 0;
                stop = true;
                return;
            }
            if (y < 0) {
                y = 0;
                stop = true;
                return;
            }
            if (x + dragElements[prop].properties.size.width > data.node.parentNode.offsetWidth) {
                x = data.node.parentNode.offsetWidth - dragElements[prop].properties.size.width;
                stop = true;
                return;
            }
            if (y + dragElements[prop].properties.size.height > data.node.parentNode.offsetHeight) {
                y = data.node.parentNode.offsetHeight - dragElements[prop].properties.size.height;
                stop = true;
                return;
            }
        }
        if (!stop)
            for (let prop in dragElements) {
                var tar = this.getElementTransform(dragElements[prop].id);
                x = tar.x;
                y = tar.y;
                var x = Math.round((x + (farkx)) * 10000) / 10000;
                var y = Math.round((y + (farky)) * 10000) / 10000;
                if (x < 0) x = 0;
                if (y < 0) y = 0;
                if (x + dragElements[prop].properties.size.width > data.node.parentNode.offsetWidth)
                    x = data.node.parentNode.offsetWidth - dragElements[prop].properties.size.width;
                if (y + dragElements[prop].properties.size.height > data.node.parentNode.offsetHeight)
                    y = data.node.parentNode.offsetHeight - dragElements[prop].properties.size.height;
                dragElements[prop].properties.location.x = x;
                dragElements[prop].properties.location.y = y;
            }
    };
    onMouseLeave = (event) => {
        return;
        event = event || window.event;
        if (event.buttons !== 1)
            return;
        const {
            changeProperties,
            changePropertiesById,
            changePropertiesRange,
            activeElement,
            RemoveIconScale,
            id
        } = this.props;
        var page = document.querySelector('[rmeditor="' + activeElement.PageId + '"]');
        console.log(activeElement.properties.location.y, activeElement.properties.size.height, page.clientHeight)
        if (activeElement.properties.location.y <= 0) {
            console.log('props', page.clientHeight, activeElement.properties.location.y + activeElement.properties.size.height)
            var el = $("#" + id);
            var cer = $('#ceren');
            var max = cer[0].scrollHeight - cer[0].clientHeight;
            console.log('TR', cer.scrollTop() + (objeler.Footer.Height + el.offset().top + el.height() - $(window.top).height()))
            cer.animate({scrollTop: cer.scrollTop() - (el.height() * 3)}, 400, 'swing');
        }
        if (activeElement.properties.location.y + activeElement.properties.size.height > page.clientHeight) {
            console.log('props', page.clientHeight, activeElement.properties.location.y + activeElement.properties.size.height)
            var el = $("#" + id);
            var cer = $('#ceren');
            var max = cer[0].scrollHeight - cer[0].clientHeight;
            console.log('TR', cer.scrollTop() + (objeler.Footer.Height + el.offset().top + el.height() - $(window.top).height()))
            cer.animate({scrollTop: cer.scrollTop() + (objeler.Footer.Height + el.offset().top + el.height() - $(window.top).height()) + (el.height() * 3)}, 400, 'swing');
        }
        return;
        {
            {
                var pageid = activeElement.PageId;
                const objs = store.getState().appReducers.objects;
                var el = document.elementFromPoint(event.clientX, event.clientY);
                console.log('el', el)
                while (el !== null && (!el.hasAttribute('id') || el.id !== 'editor')) {
                    el = el.parentElement;
                }
                if (el !== null) {
                    pageid = el.getAttribute('rmeditor');
                    ;
                    if (objs[activeElement.id].PageId !== parseInt(pageid)) {
                        {
                            var x = 0;
                            if (event.clientX - el.getBoundingClientRect().left - (this.state.dragDifPageLoc.x * 1) < 0)
                                x = 0;
                            else
                                x = event.clientX - el.getBoundingClientRect().left - 0 - (this.state.dragDifPageLoc.x / 1);
                            var y = 0;
                            if (event.clientY - el.getBoundingClientRect().top - (this.state.dragDifPageLoc.y * 1) < 0)
                                y = 0;
                            else
                                y = event.clientY - el.getBoundingClientRect().top - 0 - (this.state.dragDifPageLoc.y * 1);
                            x = x / RemoveIconScale;
                            y = y / RemoveIconScale;
                            if (x + objs[activeElement.id].properties.size.width > el.clientWidth)
                                x = (el.clientWidth - objs[activeElement.id].properties.size.width)
                            if (y + objs[activeElement.id].properties.size.height > el.clientHeight)
                                y = (el.clientHeight - objs[activeElement.id].properties.size.height);
                            if (objeler.EditorProps.ShowGridLines) {
                                x = CalcGridCoord(this.props.GridSize, x, true);
                                y = CalcGridCoord(this.props.GridSize, y, true);
                            }
                            objs[activeElement.id].PageId = parseInt(pageid);
                            objs[activeElement.id].properties.location.x = x;
                            objs[activeElement.id].properties.location.y = y;
                        }
                    }
                }
            }
        }
    }
    isElementSelected = () => {
        const {activeElementId, id} = this.props;
        return activeElementId === id;
    };

    dropElement() {
        const {alert} = objeler.Editor.props;
        alert.success("Are you sure you want to remove it?", true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.props.dropElement(this.props.id)
                        },
                    }
                ]
            }
        );
    }

    doubleClick = () => {
        // Make element active first
        const {makeElementActive, id} = this.props;
        makeElementActive(id);
        
        // Use a small delay to ensure Redux state updates before opening properties
        setTimeout(() => {
            // Use properties from this element
            const props = this.props.properties;
            console.log('doubleClick - element type:', this.props.type, 'id:', id)
            
            if (props.type == "Picture") {
            }
            ElementProps.Type = this.props.type || props.type || 'Table';
            ElementProps.Text = props.Text;
            ElementProps.Color = props.colors ? props.colors.color : 'none';
            ElementProps.BColor = props.colors ? props.colors.backgroundColor : 'none';
            ElementProps.Font = props.Font;
            ElementProps.FontFamily = props.FontFamily;
            ElementProps.FontSize = props.FontSize;
            ElementProps.FontWeight = props.FontWeight;
            ElementProps.Bold = props.Bold;
            ElementProps.Italic = props.Italic;
            ElementProps.Bound = props.Bound;
            ElementProps.Continuous = props.Continuous;
            ElementProps.Align = props.Align;
            ElementProps.CharSpacing = props.CharSpacing;
            ElementProps.DataType = props.DataType;
            ElementProps.Format = props.Format;
            ElementProps.SourceFormat = props.SourceFormat;
            ElementProps.DataSource = props.DataSource;
            ElementProps.Condition = props.Condition;
            ElementProps.Calculation = props.Calculation;
            ElementProps.CalculationKey = props.CalculationKey;
            ElementProps.ConditionKeys = props.ConditionKeys;
            ElementProps.Resource = props.Resource;
            ElementProps.MLine = props.MLine;
            ElementProps.MLineWidth = props.MLineWidth;
            ElementProps.Jpg = props.Jpg;
            ElementProps.JpgPath = props.JpgPath;
            ElementProps.JpgFileName = props.JpgFileName;
            ElementProps.JpgBlob = props.JpgBlob;
            ElementProps.JpgOriginalWidth = props.JpgOriginalWidth;
            ElementProps.JpgOriginalHeight = props.JpgOriginalHeight;
            ElementProps.JpgOriginalAspectRatio = props.JpgOriginalAspectRatio;
            ElementProps.CertFileName = props.CertFileName;
            ElementProps.CertBlob = props.CertBlob;
            ElementProps.CertPath = props.CertPath;
            ElementProps.Password = props.Password;
            ElementProps.ContentState = props.ContentState;
            ElementProps.BorderColor = props.BorderColor;
            ElementProps.Fill = props.Fill;
            ElementProps.FillColor = props.FillColor;
            ElementProps.BorderWidth = props.BorderWidth;
            ElementProps.BorderStyle = props.BorderStyle;
            ElementProps.Direction = props.Direction;
            ElementProps.BarcodeType = props.BarcodeType;
            ElementProps.QREncoding = props.QREncoding;
            ElementProps.QRLevel = props.QRLevel;
            ElementProps.QRVersion = props.QRVersion;
            ElementProps.Thickness = props.Thickness;
            ElementProps.QRUnicode = props.QRUnicode;
            ElementProps.IsScript = props.IsScript;
            ElementProps.Script = props.Script;
            
            console.log('Opening properties with ElementProps.Type:', ElementProps.Type);
            this.props.OpenProperties(this.props);
        }, 10);
    }

    makeActiveIfIsNot() {
        if (!this.isElementSelected()) {
            const {makeElementActive, id} = this.props;
            makeElementActive(id);
            objeler['selected'] = this.props.activeElement;
        }
    }

    handleDoubleClick = () => {
        alert('double click');
    }

    render() {
        const {activeElement, properties, style, children, type} = this.props;
        const {location, size} = this.isElementSelected() ? activeElement.properties : properties;
        const grd = this.props.GridSize * this.props.RemoveIconScale;
        var dragRect = '';
        if (children && children.props != undefined && children.props.type == 'Rectangle')
            dragRect = 'NoBox';
        var aspectRatio = false;
        if (children && children.props != undefined && (children.props.BarcodeType == 'QR')) {
            aspectRatio = true;
        }
        if (this.state.shiftKey)
            aspectRatio = true;
        const dragElementsLen = store.getState().appReducers.dragElements.length;
        return (
            <Rnd
                id={this.props.id}
                ref={this.parent}
                bounds="parent"
                size={size}
                position={location}
                lockAspectRatio={aspectRatio}
                scale={objeler.scale}
                resizeGrid={objeler.EditorProps.ShowGridLines && dragElementsLen == 0 ? [this.props.GridSize, this.props.GridSize] : null}
                dragGrid={objeler.EditorProps.ShowGridLines && dragElementsLen == 0 ? [grd, grd] : null}
                minWidth={-10}
                minHeight={-10}
                onClick={e => this.onSelectItem(e)}
                onDrag={this.onDrag}
                onResize={this.onResize}
                onDragStart={this.onDragStart}
                onDragStop={this.onDragStop}
                onResizeStart={this.onSelectItem}
                onDoubleClick={this.doubleClick}
                onMouseDown={(e) => {
                    e.stopPropagation();
                    this.props.onMouseDown(e)
                }}
                onMouseLeave={(e) => {
                    this.onMouseLeave(e)
                }}
                resizeHandleClasses={resizeHandlerClasses}
                className={`draggable${dragRect} ${this.isElementSelected() ? 'active' : ''}`}
                style={{...style, zIndex: properties && properties.Zindex !== undefined ? properties.Zindex : 0}}
                resizeHandleWrapperClass={`resizeHandlerWrapper ${this.isElementSelected() ? 'active' : this.isDragExist(this.props.id) ? 'drg' : ''
                }`}
            >
                {children}
                {this.isElementSelected() ? <DraggableRemoveHandler click={this.dropElement}
                                                                    RemoveIconScale={this.props.RemoveIconScale}
                /> : null}
            </Rnd>
        );
    }
}

const mapStateToProp = state => ({
    ...state,
    activeElement: state.appReducers.activeElement,
    activeElementId: state.appReducers.activeElement ? state.appReducers.activeElement.id : null
});
export default connect(
    mapStateToProp,
    {
        makeElementActive,
        changeProperties,
        changePropertiesById,
        changePropertiesRange,
        dropElement,
        doubleClick,
        updateElement,
        addToDragElements,
        removeAllDragElements,
        removeDragElements
    }
)(Draggable);
